import * as React from 'react'
import { isValidPhone } from '@sales-center/common'
import { styles } from './useStyles'
import Link from '@mui/material/Link'

export const GridPhoneLink: React.FC<{
  phone: string
  ext: string
  dataTestId?: string
}> = ({ phone, ext, dataTestId }) => {
  return isValidPhone(phone) ? (
    <Link
      href={`tel:${phone}${!!ext && ext !== '' ? `;ext=${ext}` : ''}`}
      sx={styles.link}
      data-test-id={dataTestId}
    >
      {`${phone}${!!ext && ext !== '' ? ` x${ext}` : ''}`}
    </Link>
  ) : (
    <>{phone}</>
  )
}
GridPhoneLink.displayName = 'GridPhoneLink'
